export const RECORD_USERINFO = 'RECORD_USERINFO'
export const AUTO_USERINFO = 'AUTO_USERINFO'
export const LEVELINFO = 'LEVELINFO'
export const OUT_LOGIN = 'OUT_LOGIN'
// export const BALANCE = 'BALANCE'
export const PROTECT = 'PROTECT'
export const BANKLIST = 'BANKLIST'
export const MY_BANKCARD = 'MY_BANKCARD'
export const UPDATE_BANKCARD = 'UPDATE_BANKCARD'
export const USER_WITHDRAW = 'USER_WITHDRAW'
export const BILL_GROUP = 'BILL_GROUP' // 记录分组数据
export const LOTTERYLOAD = 'LOTTERYLOAD'
export const LOTTERYMENU = 'LOTTERYMENU'
export const LOTTERYLIST = 'LOTTERYLIST'
export const GROUPLOTTERYLIST = 'GROUPLOTTERYLIST'
export const BETARRAY = 'BETARRAY'
export const CONFIG_INFO = 'CONFIG_INFO' // 网站基本信息
export const UNREADCOUNT = 'UNREADCOUNT'
export const SERVICE = 'SERVICE'
export const ALLLOTTERYID = 'ALLLOTTERYID'
export const AWCOUNT = 'AWCOUNT'
export const CREDITINFO = 'CREDITINFO'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js